<template>
    <div class="ShopInfo">
        <div class="frame">
            <div>Gift Cards</div>
            <div class="giftRemark">Looking for the perfect present ? Explore availableGift Cards.</div>
            <div class="giftBtn" @click="handleGift">show Gift Cards</div>
        </div>
        <div>
            <GoogleMap
                :apiKey="'AIzaSyDscmo5ekqMDmu5boEwQ04OWcR4qamqpgE'"
                :lat="mapLat"
                :lng="mapLng"
                :markerTitle="data.name || 'Shop location'"
                :locationName="data.name || ''"
                :locationAddress="data.address || ''"
            />
        </div>
        <div class="addressRow" v-if="data.address">
            <img src="@/assets/home/address.png" alt="address" class="addressIcon" />
            <div class="addressContent">
                <div class="addressLabel">Address</div>
                <div class="addressText">{{ data.address }}</div>
            </div>
        </div>
        <div class="phoneRows">
            <div class="mobileRow">
                <div class="mobileItem">
                    <img src="@/assets/shop/phone.png" alt="">
                    <div class="phoneText">
                        <div class="phoneLabel">Contact Phone</div>
                        <div>{{ data.link_phone || '-' }}</div>
                    </div>
                </div>
                <div class="callBtn" :class="{ disabled: !data.link_phone }" @click="handleCopyPhone(data.link_phone)">Copy</div>
            </div>
            <div class="mobileRow" v-if="data.call_phone">
                <div class="mobileItem">
                    <img src="@/assets/shop/phone.png" alt="">
                    <div class="phoneText">
                        <div class="phoneLabel">Voice Phone</div>
                        <div>{{ data.call_phone }}</div>
                    </div>
                </div>
                <div class="callBtn" @click="handleCopyPhone(data.call_phone)">Copy</div>
            </div>
            <div class="mobileRow" v-if="data.email">
                <div class="mobileItem">
                    <img src="@/assets/shop/email.png" alt="">
                    <div class="phoneText">
                        <div class="phoneLabel">Email</div>
                        <div>{{ data.email }}</div>
                    </div>
                </div>
                <div class="callBtn" @click="handleCopyEmail(data.email)">Copy</div>
            </div>
        </div>
        <van-divider />
        <div class="business-hours">
            <div class="businessTitle">Business Hours</div>
            <div class="businessItem" v-for="row in displayedBusinessHours" :key="row.key">
                <div>{{ row.label }}</div>
                <div>{{ row.timeText }}</div>
            </div>
        </div>
        <div class="weekToggle" @click="toggleFullWeek">
            <div>{{ fullWeekText }}</div>
            <van-image width="20" height="20" :src="fullWeekIcon" />
        </div>
        <van-divider />
        <div class="showWeek">
            <div class="lookAll">
                <div style="margin-bottom:.5rem">View Our Work</div>
                <div class="imageGroup">
                    <div
                        class="imageItem"
                        v-for="(item,index) in workItems"
                        :key="item.key"
                        v-if="index < allIndex"
                        :class="{ videoImageItem: item.type === 'video' }"
                    >
                        <van-image
                            v-if="item.type === 'image'"
                            radius="4"
                            width="100%"
                            height="100%"
                            :src="item.src"
                        />
                        <button
                            v-else
                            class="workVideoButton"
                            type="button"
                            @click="handleOpenWorkVideo(item.src)"
                        >
                            <video :src="item.src" muted preload="auto" playsinline></video>
                            <span class="workVideoOverlay">
                                <span class="workVideoPlay"></span>
                                <span class="workVideoLabel">Watch Video</span>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="lookBtn" @click="handleLookAll">{{lookText}}</div>
            </div>
        </div>
        <van-popup v-model="showWorkVideo" closeable round :style="{ width: '90%', background: '#000' }" @closed="handleCloseWorkVideo">
            <video
                v-if="activeWorkVideo"
                class="workVideoPlayer"
                :src="activeWorkVideo"
                controls
                autoplay
                playsinline
            ></video>
        </van-popup>
        <van-divider />
       <!-- 设施 -->
       <div></div>
       <!-- 评价下沉到店铺信息页底部 -->
       <ShopComments :shop_supplier_id="shop_supplier_id" />
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin';
import GoogleMap from '@/components/GoogleMap/index.vue'
import ShopComments from './comments.vue'
export default{
    name:'ShopInfo',
    props:{
        data:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        shop_supplier_id:{
            type:[String,Number],
            default:''
        }
    },
    mixins: [myMixin],
    components:{
        GoogleMap,
        ShopComments
    },
    data(){
        return {
            activeNames:['1'],
            allIndex:4,
            lookText:'View All',
            showFullWeek:false,
            showWorkVideo:false,
            activeWorkVideo:'',
        }
    },
    computed: {
        workItems(){
            const images = Array.isArray(this.data && this.data.image) ? this.data.image : []
            const imageItems = images
                .map((item, index) => ({
                    type: 'image',
                    key: `image-${item && item.id ? item.id : index}`,
                    src: this.getMediaUrl(item)
                }))
                .filter(item => item.src)
            const videos = Array.isArray(this.data && this.data.videos) ? this.data.videos : []
            const videoItems = videos
                .map((item, index) => ({
                    type: 'video',
                    key: `video-${item && item.id ? item.id : index}`,
                    src: this.getMediaUrl(item)
                }))
                .filter(item => item.src)
            return [...imageItems, ...videoItems]
        },
        fullWeekText(){
            return this.showFullWeek ? 'Hide all week' : 'Show full week'
        },
        fullWeekIcon(){
            return this.showFullWeek ? require('@/assets/shop/up.png') : require('@/assets/shop/down.png')
        },
        businessHoursAll(){
            const d = this.data || {}
            const rows = [
                { key: 'sunday', label: 'Sunday', start: d.sunday_start, end: d.sunday_end },
                { key: 'mondy', label: 'Monday', start: d.mondy_start, end: d.mondy_end },
                { key: 'tuesday', label: 'Tuesday', start: d.tuesday_start, end: d.tuesday_end },
                { key: 'wednesday', label: 'Wednesday', start: d.wednesday_start, end: d.wednesday_end },
                { key: 'thursday', label: 'Thursday', start: d.thursday_start, end: d.thursday_end },
                { key: 'friday', label: 'Friday', start: d.friday_start, end: d.friday_end },
                { key: 'saturday', label: 'Saturday', start: d.saturday_start, end: d.saturday_end },
            ]
            return rows.map(r => {
                const start = r.start || '00:00:00'
                const end = r.end || '00:00:00'
                return {
                    ...r,
                    start,
                    end,
                    timeText: this.formatBusinessHours(start, end)
                }
            })
        },
        todayKey(){
            const map = ['sunday', 'mondy', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
            return map[new Date().getDay()] || 'tuesday'
        },
        displayedBusinessHours(){
            if(this.showFullWeek) {
                // All展示：把今日那一行标成 Today
                return this.businessHoursAll.map(r => ({
                    ...r,
                    label: r.key === this.todayKey ? 'Today' : r.label
                }))
            }
            // 默认展示 3 条：Sunday、Monday、Today（避免重复时补足到 3 条）
            const preferred = ['sunday', 'mondy', this.todayKey]
            const keys = []
            for(const k of preferred){
                if(!keys.includes(k)) keys.push(k)
            }
            const allKeys = this.businessHoursAll.map(r => r.key)
            for(const k of allKeys){
                if(keys.length >= 3) break
                if(!keys.includes(k)) keys.push(k)
            }
            return this.businessHoursAll
                .filter(r => keys.includes(r.key))
                .map(r => ({
                    ...r,
                    label: r.key === this.todayKey ? 'Today' : r.label
                }))
        },
        mapLat(){
            const v = this.data && this.data.latitude
            const n = Number(v)
            return Number.isFinite(n) ? n : 39.9042
        },
        mapLng(){
            const v = this.data && this.data.longitude
            const n = Number(v)
            return Number.isFinite(n) ? n : 116.4074
        }
    },
    mounted(){
    },
    methods:{
        toggleFullWeek(){
            this.showFullWeek = !this.showFullWeek
        },
        handleLookAll(){
            if(this.allIndex == 4 ){
                this.lookText = 'Collapse Images'
                this.allIndex = this.workItems.length + 1
            }else{
                this.lookText = 'View All'
                this.allIndex = 4
            }
        },
        getMediaUrl(file){
            if(!file) return ''
            if(typeof file === 'string' || typeof file === 'number'){
                return this.getUrl(file)
            }
            return this.getUrl(file.file_path || file.file_url || file.url || file.path || file.save_name || file)
        },
        handleOpenWorkVideo(src){
            if(!src) return
            this.activeWorkVideo = src
            this.showWorkVideo = true
        },
        handleCloseWorkVideo(){
            this.activeWorkVideo = ''
        },
        handleGift(){
            this.$router.push({
                path: '/giftCard',
                query: {
                    shop_supplier_id: this.shop_supplier_id
                }
            })
        },
        formatBusinessHours(start, end){
            const toMinute = (timeValue) => {
                if(!timeValue) return '00:00'
                const s = String(timeValue)
                const parts = s.split(':')
                if(parts.length < 2) return '00:00'
                const hour = (parts[0] || '00').padStart(2, '0').slice(-2)
                const minute = (parts[1] || '00').padStart(2, '0').slice(-2)
                return `${hour}:${minute}`
            }
            const startMinute = toMinute(start)
            const endMinute = toMinute(end)
            if(startMinute === '00:00' && endMinute === '00:00'){
                return 'Closed'
            }
            return `${startMinute}-${endMinute}`
        },
        _fallbackCopy(value, msg) {
            const textArea = document.createElement('textarea')
            textArea.value = value
            textArea.setAttribute('readonly', '')
            textArea.style.position = 'fixed'
            textArea.style.top = '-9999px'
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
            this.$toast(msg)
        },
        handleCopyPhone(phone){
            const value = String(phone || '').trim()
            if (!value) {
                this.$toast('No phone number')
                return
            }
            if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(value).then(() => {
                    this.$toast('Phone number copied')
                }).catch(() => {
                    this._fallbackCopy(value, 'Phone number copied')
                })
            } else {
                this._fallbackCopy(value, 'Phone number copied')
            }
        },
        handleCopyEmail(email) {
            const value = String(email || '').trim()
            if (!value) {
                this.$toast('No email address')
                return
            }
            if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(value).then(() => {
                    this.$toast('Email address copied')
                }).catch(() => {
                    this._fallbackCopy(value, 'Email address copied')
                })
            } else {
                this._fallbackCopy(value, 'Email address copied')
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .ShopInfo{
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
        .workVideoPlayer{
            width: 100%;
            max-height: 70vh;
            display: block;
            background: #000;
        }
        .weekToggle{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.25rem;
            color: #1E3C3E;
            font-size: .875rem;
            padding: 0.5rem 0;
            user-select: none;
        }
        .showWeek{
            margin: 1rem 0;
            .lookAll{
                .imageGroup{
                    display: flex;
                    flex-wrap: wrap;
                    .imageItem{
                        width: calc(100% / 4);
                        height: 6.25rem;
                        padding:.5rem;
                        box-sizing: border-box;
                        .workVideoButton{
                            position: relative;
                            width: 100%;
                            height: 100%;
                            padding: 0;
                            border: 0;
                            border-radius: .25rem;
                            overflow: hidden;
                            background: #f4f4f4;
                            display: block;
                            video{
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                display: block;
                            }
                        }
                        .workVideoOverlay{
                            position: absolute;
                            inset: 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            gap: .25rem;
                            background: transparent;
                            color: #fff;
                            font-size: .625rem;
                            font-weight: 600;
                        }
                        .workVideoPlay{
                            width: 2rem;
                            height: 2rem;
                            border-radius: 50%;
                            background: rgba(255, 255, 255, .88);
                            position: relative;
                            &::after{
                                content: '';
                                position: absolute;
                                left: .8125rem;
                                top: .5625rem;
                                border-left: .6875rem solid #1E3C3E;
                                border-top: .4375rem solid transparent;
                                border-bottom: .4375rem solid transparent;
                            }
                        }
                        .workVideoLabel{
                            padding: .1875rem .375rem;
                            border-radius: 999px;
                            background: rgba(0, 0, 0, .16);
                            line-height: 1.2;
                            text-shadow: 0 1px 2px rgba(0, 0, 0, .35);
                        }
                    }
                }
                .lookBtn{
                    width: 100%;
                    height: 2.25rem;
                    background: #fff;
                    border-radius: .25rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: .875rem;
                    border: 1px solid #EEEEEE;
                }
            }
        }
        .frame{
            width: 100%;
            height: 8.75rem;
            background-image: url('@/assets/shop/frame.png');
            background-repeat: no-repeat;
            background-size: cover;
            padding: 1rem;
            box-sizing: border-box;
            color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin: 1rem 0;
            .giftRemark{
                font-size: .75rem;
            }
            .giftBtn{
                width: fit-content;
                height: 2rem;
                border-radius: .25rem;
                border: 1px solid #E2E2E2;
                padding: 0 1rem;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .addressRow{
            display: flex;
            align-items: flex-start;
            gap: .5rem;
            margin-bottom: .75rem;
            background: #F0F7F6;
            padding: .625rem .75rem;
            border-radius: .25rem;
            .addressIcon{
                flex: 0 0 auto;
                width: 2rem;
                height: 2rem;
                display: block;
                margin-top: .125rem;
            }
            .addressContent{
                flex: 1;
                min-width: 0;
                .addressLabel{
                    color: #666666;
                    font-size: .75rem;
                    margin-bottom: .125rem;
                }
                .addressText{
                    font-size: 1rem;
                    color: #1E3C3E;
                    line-height: 1.4;
                    word-break: break-word;
                }
            }
        }
        .phoneRows{
            display: flex;
            flex-direction: column;
            gap: .75rem;
        }
        .mobileRow{
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: .75rem;
            background: #F0F7F6;
            padding: .625rem .75rem;
            border-radius: .25rem;
            .mobileItem{
                display: flex;
                align-items: center;
                flex: 1;
                min-width: 0;
                font-size: 1.25rem;
                color: #1E3C3E;
                img{
                    flex: 0 0 auto;
                    width: 2rem;
                    height: 2rem;
                    display: block;
                    margin-right: 0.5rem;
                }
            }
            .phoneText{
                min-width: 0;
                word-break: break-word;
                line-height: 1.25;
            }
            .phoneLabel{
                color: #666666;
                font-size: .75rem;
                margin-bottom: .125rem;
            }
            .callBtn{
                flex: 0 0 auto;
                width: 3.625rem;
                height: 2.25rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: #1E3C3E;
                border: 3px solid #D2D8D8;
                border-radius: .25rem;
                box-sizing: border-box;
                font-size: .875rem;
            }
            .callBtn.disabled{
                opacity: .45;
            }
        }
        .business-hours{
            .businessTitle{
                font-size: .875rem;
                color: #333344;
                margin-bottom: 0.5rem;
            }
            .businessItem{
                width: 100%;
                display: flex;
                justify-content: space-between;
                font-size: .75rem;
                color: #666666;
                margin-bottom: 0.5rem;
            }
        }
    }
</style>
